import { omit } from "lodash";
import axios from "axios"
import { getParams } from "./AuraFunctions";
import { contentTypeOf } from "./fileSource";

async function downloadFile({ params, endPoint }) {
    const { filterObj, headerObj } = getParams()
    const headers = omit(headerObj, ['App-Pagination-Limit', 'App-Pagination-Num']);
    // const response = await axios.get(endPoint, { params: { ...params, ...filterObj }, headers, responseType: 'blob' })
    const response = await axios({
        method: 'get',
        url: endPoint,
        params: { ...params, ...filterObj },
        headers,
        responseType: 'blob'
    })
        .then((res) => {
            const disposition = res.headers['content-disposition']
            const matches = /filename=(.+)/.exec(disposition)
            const fileName = matches != null && matches[1] ? matches[1].slice(1, -1) : null

            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', fileName || 'orders.xlsx'); // or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        });

    return response;
}

export const downloadFromResponse = (res) => {
    const disposition = res.headers['content-disposition']
    const matches = /filename=(.+)/.exec(disposition)
    const fileName = matches != null && matches[1] ? matches[1].slice(1, -1) : null

    // create file link in browser's memory
    const href = URL.createObjectURL(res.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName || 'orders.xlsx'); // or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
}

/**
 * Trigger a browser download for a file payload carried on a communication / note attachment.
 *
 * PGSS-5548: after PGSS-5505, S3 responses put a short-lived signed link on `url` and leave `data`
 * empty. This helper used to always `atob(data)`, so the Communication download button failed
 * silently. Prefer the link when present (same rule as handleDownload / resolveFileSrc); keep the
 * base64 path for local / non-S3 responses that still embed bytes.
 *
 * Remote links open in a new tab — same as handleDownload (PGSS-5535). Cross-origin `download` is
 * ignored by the browser, so without target=_blank the file would navigate over the current page.
 *
 * Call sites: order Communication tab, AuraCommunication (shipment communication / shared notes).
 * Attachments dialog / View Order / ImageRenderer use handleDownload instead.
 */
export const downloadFileAttachments = (responseData) => {
    if (!responseData) {
        return;
    }

    const filename = responseData.filename || responseData.name || 'attachment';
    const mime = contentTypeOf(responseData) || responseData.mime;
    const remoteUrl = responseData.url;

    if (remoteUrl) {
        const link = document.createElement('a');
        link.href = remoteUrl;
        link.download = filename;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return;
    }

    if (!responseData.data) {
        return;
    }

    const byteCharacters = atob(responseData.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const fileBlob = new Blob([byteArray], { type: mime });

    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(fileUrl);
    document.body.removeChild(link);
}

export default downloadFile
